<template>
    <div class="d-flex justify-content-center">
        <input 
            ref="uploadImage" 
            type="file" 
            accept=".jpg, .png, .jpeg" 
            @change="uploadImage" 
            hidden
        />
        <div class="circular-image-preview centered" v-if="imageFile.preview" @click="trigger()">
            <img :src="imageFile.preview" alt="image file">
        </div>
        <div class="image-preview" @click="trigger()" v-else>
            <span>
                <i class="fas fa-image"></i><br>
                กดเลือกรูปภาพ
            </span>
        </div>
    </div>
</template>

<script>
import Compressor from 'compressorjs'
export default {
    props:{
        imageFile: Object
    },
    methods:{
        trigger(){
          this.$refs.uploadImage.click()
        },
        uploadImage(e){
            if (e.target.files.length < 1) return false;
            const image = e.target.files[0]
            let SELF = this
            new Compressor(image, {
                quality: 0.6,
                maxHeight: 1024,
                maxHeight: 1024,
                convertSize: 2000000,
                success(result) {
                    const reader = new FileReader();
                        reader.readAsDataURL(result)
                        reader.onload = e => {
                            SELF.$set(SELF.imageFile, 'preview' , e.target.result)
                            SELF.imageFile.file = result;
                        }
                }
            })
        }
    }
}
</script>